import Bowser from 'bowser';

const browser = Bowser.getParser(window.navigator.userAgent);

export const checkBrowser = () => {
  return browser.satisfies({
    desktop: {
      chrome: '>=60',
      firefox: '>=60',
      edge: '>=15',
      opera: '>=50',
      safari: '>=10.1',
    },
    tablet: {
      chrome: '>=76',
      safari: '>=11',
    },
  });
};



// WEBPACK FOOTER //
// ./src/main/ui/react/helpers/browserCheck.js